// extracted by mini-css-extract-plugin
export default {"layout":"\"../../styles/variables/layout.module.css\"","breakpoint-m":"840px","gap-m":"16px","custom-wrapper":"ArticlesWidgets_custom-wrapper__S77gw"};